import { __decorate } from "tslib";
// NPM
import { Component, Vue } from "vue-property-decorator";
import { Guid } from "guid-typescript";
import { setInteractionMode } from "vee-validate";
setInteractionMode("passive");
// SYSTEM1
import Layout from "../../layouts/auth.vue";
import { AuthModule } from "../../../store/modules/auth.module";
import { SettingModule } from "../../../store/modules/settings.module"; // settings module
import { NotificationsModule } from "../../../store/modules/notification.module";
import { UserLoginModel } from "@/store/models/userLoginAnalytics/userLogin";
import { ClockWorkModule } from "@/store/modules/clockWork.module";
import Swal from "sweetalert2";
import { RightsConstant } from "@/store/securityRightConstant";
import { hasRight } from "@/store/helper";
let TenantGateway = /** @class */ (() => {
    let TenantGateway = class TenantGateway extends Vue {
        constructor() {
            super(...arguments);
            this.pageIsLoading = true;
            this.isAccessDenied = false;
            this.tenant = { id: null, name: "", isUserAssigned: false };
            this.userLoginDetails = new UserLoginModel();
        }
        chooseTenant() {
            this.validate().then((response) => {
                if (response) {
                    SettingModule.AssignSelectedTenant(this.tenant);
                    SettingModule.GetUserProfile().then((response) => {
                        if (!this.IsTenantUserHasOrganizationSetting) {
                            this.$router.push({ name: "OrganizationSetting" });
                        }
                        else {
                            this.saveUserLoginDetails();
                            if (this.rightsHelper(this.rightsConstant.Clockwork.BasicPrivilege())) {
                                this.checkMidNightCrossOver();
                            }
                            else {
                                this.getCurrentRoute();
                            }
                        }
                    });
                }
            });
        }
        async saveUserLoginDetails() {
            this.userLoginDetails.tenantId = this.tenant.id.toString();
            await AuthModule.SaveUserLoginDetails(this.userLoginDetails);
        }
        backToSignIn() {
            AuthModule.Logout();
        }
        getCurrentRoute() {
            const redirectRoute = localStorage.getItem("TenantGatewayRedirectRoute");
            if (redirectRoute && redirectRoute != "/") {
                this.$router.push(redirectRoute);
            }
            else {
                this.$router.push({ name: "DashBoard" });
            }
        }
        checkMidNightCrossOver() {
            ClockWorkModule.GetClockWorkRunningEntries().then(async (response) => {
                await this.getCurrentRoute();
                if (response.clockWorkRunningEntries.length > 0) {
                    var currentRoute = this.$router;
                    if (currentRoute.history.pending == null || currentRoute.history.pending.name != "ClockWork") {
                        Swal.fire({
                            title: `You have a live ClockWork entry running!`,
                            text: "Please adjust the entry to continue using Clockwork.",
                            icon: "warning",
                            showCancelButton: true,
                            confirmButtonColor: "#34c38f",
                            cancelButtonColor: "#f46a6a",
                            confirmButtonText: "Proceed to Fix",
                            cancelButtonText: "Do Later",
                        }).then((result) => {
                            if (result.value) {
                                this.$router.push({ name: "ClockWork" });
                            }
                        });
                    }
                }
            });
        }
        get tenants() {
            return SettingModule.tenants.filter((x) => x.isUserAssigned == true);
        }
        get IsTenantUserHasOrganizationSetting() {
            return SettingModule.IsUserHasOrganizationSettings;
        }
        get rightsConstant() {
            return RightsConstant;
        }
        get rightsHelper() {
            return hasRight;
        }
        validate() {
            let form = this.$refs.observer;
            return form.validate().then((valid) => {
                if (this.tenant.id.toString() == Guid.parse(Guid.EMPTY).toString()) {
                    return false;
                }
                else {
                    return true;
                }
            });
        }
        created() {
            this.tenant = {
                id: Guid.parse(Guid.EMPTY),
                name: "Select",
                isUserAssigned: false,
            };
            SettingModule.FindUserRole().then((roleResponse) => {
                if (roleResponse.isTenantAdmin == true || roleResponse.isClientUser == true) {
                    this.isAccessDenied = false;
                    SettingModule.GetTenants().then((response) => {
                        this.pageIsLoading = false;
                        if (this.tenants.length == 1) {
                            this.tenant = this.tenants[0];
                            this.chooseTenant();
                            NotificationsModule.GetNotificationCount(this.tenant.id.toString()).then((response) => { });
                        }
                        else {
                            this.tenants.splice(0, 0, this.tenant);
                        }
                    });
                }
                else {
                    this.pageIsLoading = false;
                    this.isAccessDenied = true;
                }
            });
        }
    };
    TenantGateway = __decorate([
        Component({
            name: "TenantGateway",
            components: {
                Layout,
            },
        })
    ], TenantGateway);
    return TenantGateway;
})();
export default TenantGateway;
